import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, CircularProgress } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import axios from '../../Configs/axiosInstance';
import { MAIN_URL } from '../../Configs/Urls';
import PatientDietForm from './Patient-Diet-Form';

// Thin routing wrapper around the (unchanged) PatientDietForm component.
// It only resolves the URL's :id into the props PatientDietForm already
// expects (patientId, name, planId, selectedWeekdefault) — none of
// PatientDietForm's own state/save/local-draft logic is touched.
export default function PatientDietPlanEditPage() {
  const { id: planId } = useParams();
  const navigate = useNavigate();

  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!planId) return;

    setLoading(true);
    axios
      .get(`${MAIN_URL}patientdietplans/${planId}`)
      .then((response) => {
        const { patientId, patientName, weekDateStart, weekDateEnd } = response.data.DietPlan;
        setMeta({
          patientId,
          patientName,
          selectedWeekdefault: `${weekDateStart} - ${weekDateEnd}`,
        });
      })
      .finally(() => setLoading(false));
  }, [planId]);

  const goBack = () => navigate('/patient-diet');

  if (loading || !meta) {
    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Button
        startIcon={<ArrowBackRoundedIcon />}
        onClick={goBack}
        sx={{ mb: 2, textTransform: 'none', fontWeight: 600 }}
      >
        Back to Diet Plans List
      </Button>

      <PatientDietForm
        showPatientInfo
        patientId={meta.patientId}
        name={meta.patientName}
        planId={planId}
        selectedPlansWeeks={[]}
        selectedWeekdefault={meta.selectedWeekdefault}
        onCloseForm={goBack}
      />
    </Box>
  );
}
